import type { UploadError } from '@application/ports';

/**
 * What to tell someone whose upload failed.
 *
 * Each case names the thing they can act on. "No se pudo subir el archivo" is the
 * message that generates a support ticket, because the person cannot tell a file
 * that is too big from one the rules refused — and those have opposite fixes.
 */
export const describeUpload = (error: UploadError): string => {
  switch (error.kind) {
    case 'too-large':
      return `El archivo pesa ${formatMegabytes(error.bytes)} y el máximo es ${formatMegabytes(
        error.limit,
      )}. Comprime el PDF e intenta de nuevo.`;
    case 'wrong-type':
      return 'El documento debe ser un PDF. Exporta el archivo y vuelve a adjuntarlo.';
    case 'permission-denied':
      return 'Tu cuenta no puede subir documentos a esa carpeta. Avisa a RR.HH.';
    case 'network':
      return 'Se interrumpió la subida. Revisa tu conexión e intenta de nuevo.';
    default:
      return 'No pudimos guardar el archivo. Intenta de nuevo en un momento.';
  }
};

const formatMegabytes = (bytes: number): string =>
  `${(bytes / (1024 * 1024)).toLocaleString('es-MX', { maximumFractionDigits: 1 })} MB`;
